import {
    Component,
    OnInit,
    Input,
    trigger,
    transition,
    style,
    animate,
    state,
    Output,
    EventEmitter,
    NgZone,
    SimpleChanges
} from "@angular/core";
import {
    Booking,
    Totals,
    Addon,
    TpProduct
} from "../../../shared/models/booking.model";
import {
    Validators,
    FormGroup,
    FormArray,
    FormBuilder,
    AbstractControl
} from "@angular/forms";
import {
    Passenger,
    PassengerFormModel,
    UpdatePassengerOption
} from "../../../shared/models/passenger.model";
import { Country } from "../../../shared/models/country.model";
import {
    TravelProductService,
    TravelPackage,
    FareTypeChangedEvent,
    TicketBookingOptions,
    CartItemOptions
} from "../../../shared/services/travel-product.service";
import { Router } from "@angular/router";
import {
    ActionUpdaterService,
    ApiError
} from "../../../shared/services/action-updater.service";
import { DecimalPipe } from "@angular/common";

import {
    PaymentService,
    CreatePaymentOptions,
    CreatePaymentResult,
    TnsCreditCardOptions,
    TnsResponse,
    TnsOptions,
    LoyaltyOptions,
    ConfirmAndTicketOptions
} from "../../../shared/services/payment.service";

import * as _ from "lodash";
import * as moment from "moment";
import {
    CreditCardService,
    VALID_CARD_TYPES
} from "app/shared/services/credit-card.service";
import { GxConstants } from "app/shared/constants/gx.constants";
import { InitialDataService } from "../../../initial-data.service";
import { ProductTypeUrl } from "app/shared/models/enums/ProductTypeUrl.enum";
import { LocalStorageService } from "../../../shared/services/local-storage.service";
import { MyGreyhoundService } from "app/my-greyhound/my-greyhound.service";
import { CartTotalService } from "../../../shared/services/cart-total.service";
import { AddonsService } from "../../../shared/services/addons.service";
import {
    BookingService,
    DeleteTourByGuidOptions
} from "app/shared/services/booking.service";
import { FeatureService, Feature } from "app/shared/services/feature.service";

@Component({
    selector: "gaweb-payment-form",
    templateUrl: "./payment-form.component.html"
})
export class PaymentFormComponent implements OnInit {
    @Output() totalsUpdate: EventEmitter<Totals> = new EventEmitter();

    @Input() totals: Totals;
    @Input() loadingData: boolean;
    @Input() bookingGuid: string;
    @Input() transactionNumber: string;
    @Input() paymentContext: string;
    @Input() productReference: string;
    @Input() productType: ProductTypeUrl;

    public ccForm: FormGroup;
    paying = false;
    ccActive = true;
    paypalActive = false;
    loyaltyDollarsActive = false;
    loyaltyEnabled = false;
    alertsTNS: Array<ApiError>;
    cardType: string;
    alertsPayPal: Array<ApiError>;
    alertsLoyalty: Array<ApiError>;

    // Loyalty
    public loyaltyCcForm: FormGroup;
    public loyaltyAmount = 0.0;
    public loyaltyAvailable = 0.0;
    public loyaltyPending = 0.0;
    public totalLoyalty = 0.0;
    public maxLoyaltyPayable = 0.0;
    public partialLoyaltyPayment = true;
    public partialLoyaltyPaymentMode = "cc";

    public balanceTime: Date;
    public usingCredit = 0.0;
    public processingFee = 0.0;
    public balanceToPay = 0.0;
    public orderSummary = 0.0;

    public processingCart = false;
    public loadingBalance = true;

    public addons = new Array<CartItemOptions>();
    public loyaltyTotals: Totals;

    public booking: any;

    public greenDollarTotal = 0;
    public removingGreenDollar = false;

    customerGuid = null;

    constructor(
        private _fb: FormBuilder,
        private pipe: DecimalPipe,
        private paymentService: PaymentService,
        private bookingService: BookingService,
        private myGreyhoundService: MyGreyhoundService,
        private creditCardService: CreditCardService,
        private initialDataService: InitialDataService,
        private localStorageService: LocalStorageService,
        private actionUpdaterService: ActionUpdaterService,
        private cartTotalService: CartTotalService,
        private featureService: FeatureService
    ) {}

    ngOnInit() {
        this.customerGuid = !!this.initialDataService.initialData.UserData
            ? this.initialDataService.initialData.UserData.CustomerGuid
            : null;
        this.booking = this.localStorageService.getOfflineBooking();

        if (this.customerGuid != null) {
            this.updateLoyaltyBalance();
        }
        const booking = this.localStorageService.getOnlineBooking();
        if (booking.ProductType === "EX" && this.customerGuid != null) {
            const customerGuid = !!this.initialDataService.userData
                ? this.initialDataService.userData.CustomerGuid
                : null;

            if (
                moment(
                    this.featureService.GetFeatureValue(Feature.LastTCUpdate)
                ).isAfter(
                    moment(this.initialDataService.userData.TCAcceptDate)
                ) &&
                this.localStorageService.getIfTCUpdated(customerGuid) ===
                    "false"
            ) {
                this.loyaltyEnabled = false;
            } else {
                this.loyaltyEnabled = true;
            }
        }

            booking.TpProducts.forEach(tpProduct => {
                if (tpProduct.ProductCode === "GRNDOLLAR") {
                    console.log("tpProducts", tpProduct);
                    this.greenDollarTotal +=
                        tpProduct.SalePrice * tpProduct.QuantityToBook;
                }
            });

            booking.Tours.forEach(tour => {
                if (tour.SelectedFareType === "GRNDOLLAR" && tour.TicketNumber === null) {
                    console.log("tour", tour);
                    this.greenDollarTotal +=
                        tour.SelectedCurrencyAmount * tour.Quantity;
                }
            });


        console.log("flag b,  this.greenDollarTotal", this.greenDollarTotal);

        this.ccForm = this._fb.group({
            number: ["", Validators.required],
            month: ["", Validators.required],
            year: ["", Validators.required],
            cvv: ["", Validators.required]
        });

        this.loyaltyCcForm = this._fb.group({
            number: ["", Validators.required],
            month: ["", Validators.required],
            year: ["", Validators.required],
            cvv: ["", Validators.required]
        });

        this.ccForm.valueChanges
            .debounceTime(500)
            .subscribe(({ number, month, year, cvv }) => {
                number = this.creditCardService.formatCardNumber(number);
                month = month.replace(/\D/g, "");
                const intMonth = parseInt(month);
                if (intMonth < 1 || intMonth > 12) {
                    this.ccForm.controls["month"].setErrors(
                        { expirymonth: true },
                        { emitEvent: false }
                    );
                    return;
                }
                year = year.replace(/\D/g, "");
                const intYear = parseInt(year);
                if (intYear < parseInt(moment().format("YY"))) {
                    this.ccForm.controls["year"].setErrors(
                        { expiryyear: true },
                        { emitEvent: false }
                    );
                    return;
                }
                cvv = cvv.replace(/\D/g, "");
                this.ccForm.setValue(
                    { number, month, year, cvv },
                    { emitEvent: false }
                );
                this.cardType = this.creditCardService.cardTypeFromNumber(
                    number
                );
                if (
                    number.length > 3 &&
                    VALID_CARD_TYPES.indexOf(this.cardType) < 0
                ) {
                    this.ccForm.controls["number"].setErrors(
                        { cardtype: true },
                        { emitEvent: false }
                    );
                }
            });

        this.loyaltyCcForm.valueChanges
            .debounceTime(500)
            .subscribe(({ number, month, year, cvv }) => {
                number = this.creditCardService.formatCardNumber(number);
                month = month.replace(/\D/g, "");
                const intMonth = parseInt(month);
                if (intMonth < 1 || intMonth > 12) {
                    this.loyaltyCcForm.controls["month"].setErrors(
                        { expirymonth: true },
                        { emitEvent: false }
                    );
                    return;
                }
                year = year.replace(/\D/g, "");
                const intYear = parseInt(year);
                if (intYear < parseInt(moment().format("YY"))) {
                    this.loyaltyCcForm.controls["year"].setErrors(
                        { expiryyear: true },
                        { emitEvent: false }
                    );
                    return;
                }
                cvv = cvv.replace(/\D/g, "");
                this.loyaltyCcForm.setValue(
                    { number, month, year, cvv },
                    { emitEvent: false }
                );
                this.cardType = this.creditCardService.cardTypeFromNumber(
                    number
                );
                if (
                    number.length > 3 &&
                    VALID_CARD_TYPES.indexOf(this.cardType) < 0
                ) {
                    this.loyaltyCcForm.controls["number"].setErrors(
                        { cardtype: true },
                        { emitEvent: false }
                    );
                }
            });
        window.scrollTo(0, 0);
    }

    ngOnChanges(changes: SimpleChanges) {
        this.updateLoyaltyBalance();
    }

    updateFromInput() {
        this.orderSummary = 0.0;
        this.addons = new Array<CartItemOptions>();
        let farePrice = 0;

        if (this.totals == null) {
            return;
        }

        if (this.removingGreenDollar) {
            this.addons = this.addons.filter(
                addon => addon.productCode !== "GRNDOLLAR"
            );
            const oldTravelProducts = this.totals.PaymentItems.filter(
                paymentItems =>
                    paymentItems != null &&
                    paymentItems.Description === "Travel Products"
            )[0];
            if (oldTravelProducts != null) {
                oldTravelProducts.Items = oldTravelProducts.Items.filter(
                    item => item.ProductCode !== "GRNDOLLAR"
                );
            }
            this.totals.PaymentItems = this.totals.PaymentItems.filter(
                paymentItems =>
                    paymentItems != null &&
                    paymentItems.Description !== "Travel Products"
            );
            this.totals.PaymentItems.push(oldTravelProducts);
        }

        this.totals.PaymentItems.forEach(paymentItem => {
            if (paymentItem != null) {
                if (paymentItem.Sku === "FE") {
                    this.processingFee = paymentItem.Total;
                } else if (paymentItem.Sku === "IN") {
                } else if (paymentItem.Sku === "TP") {
                    paymentItem.Items.forEach(item => {
                        const newCartItem = new CartItemOptions();
                        newCartItem.Type = paymentItem.Sku;
                        newCartItem.productCode = item.ProductCode;
                        newCartItem.SalePriceUnit = item.Amount;
                        newCartItem.Quantity = item.Quantity;
                        this.addons.push(newCartItem);

                        this.orderSummary += item.Amount * item.Quantity;
                    });
                } else {
                    this.orderSummary += paymentItem.Total;
                    if (paymentItem.Sku !== "FP") {
                        paymentItem.Items.forEach(item => {
                            const newCartItem = new CartItemOptions();
                            newCartItem.Type = paymentItem.Sku;
                            newCartItem.productCode = item.ProductCode;
                            newCartItem.SalePriceUnit = item.Amount;
                            newCartItem.Quantity = item.Quantity;
                            this.addons.push(newCartItem);
                        });
                    } else {
                        farePrice = paymentItem.Total;
                        this.totals.PaymentItems.forEach(paymentItem => {
                            if (paymentItem != null) {
                                if (paymentItem.Sku === "IN") {
                                    this.orderSummary += paymentItem.Total;
                                    const newCartItem = new CartItemOptions();
                                    newCartItem.Type = paymentItem.Sku;
                                    newCartItem.productCode =
                                        paymentItem.Items[0].ProductCode;
                                    newCartItem.SalePriceUnit = farePrice;
                                    newCartItem.Quantity = 1;
                                    this.addons.push(newCartItem);
                                }
                            }
                        });
                    }
                }
            }
        });

        this.balanceToPay = this.totals.TotalCost;

        if (this.orderSummary < this.loyaltyAvailable) {
            this.maxLoyaltyPayable = this.orderSummary;
        } else {
            this.maxLoyaltyPayable = this.loyaltyAvailable;
        }

        if (
            this.greenDollarTotal > 0 &&
            this.loyaltyAvailable > this.orderSummary
        ) {
            this.maxLoyaltyPayable -= this.greenDollarTotal;
        }
    }

    removeGreenDollar() {
        this.removingGreenDollar = true;
        const onlineBooking = this.localStorageService.getOnlineBooking();
        let greenDollarGuid = "";

        onlineBooking.TpProducts.forEach(tpProduct => {
            if (tpProduct.ProductCode === "GRNDOLLAR") {
                greenDollarGuid = tpProduct.TourGuid;
            }
        });

        onlineBooking.Tours.forEach(tour => {
            if (tour.SelectedFareType === "GRNDOLLAR") {
                greenDollarGuid = tour.TourGuid;
            }
        });

        this.addons = this.addons.filter(
            addon => addon.productCode !== "GRNDOLLAR"
        );
        const oldTravelProducts = this.totals.PaymentItems.filter(
            paymentItems =>
                paymentItems != null &&
                paymentItems.Description === "Travel Products"
        )[0];

        if (oldTravelProducts != null) {
            oldTravelProducts.Items = oldTravelProducts.Items.filter(
                item => item.ProductCode !== "GRNDOLLAR"
            );
        }
        this.totals.PaymentItems = this.totals.PaymentItems.filter(
            paymentItems =>
                paymentItems != null &&
                paymentItems.Description !== "Travel Products"
        );
        this.totals.PaymentItems.push(oldTravelProducts);

        console.log("greenDollarGuid", greenDollarGuid);

        if (greenDollarGuid === "") {
            this.greenDollarTotal = 0;
            const options = this.cartTotalService.getExpressCartTotalOptions(
                this.booking.travels,
                1,
                null,
                false,
                this.customerGuid
            );
            this.addons.forEach(addon => {
                if (addon.productCode !== "GRNDOLLAR") {
                    options.CartItems.push(addon);
                }
            });

            this.cartTotalService.postCartTotal(
                options,
                response => {
                    this.totals = response;
                    this.totalsUpdate.emit(response);
                    this.onKeyUp(this.loyaltyAmount, null);
                    this.updateFromInput();
                    this.removingGreenDollar = false;
                },
                null,
                null,
                null
            );
            return;
        }

        this.bookingService
            .deleteTourByGuid(
                new DeleteTourByGuidOptions(
                    onlineBooking.BookingGuid,
                    greenDollarGuid
                )
            )
            .subscribe(result => {
                this.greenDollarTotal = 0;
                const options = this.cartTotalService.getExpressCartTotalOptions(
                    this.booking.travels,
                    1,
                    null,
                    false,
                    this.customerGuid
                );
                this.addons.forEach(addon => {
                    if (addon.productCode !== "GRNDOLLAR") {
                        options.CartItems.push(addon);
                    }
                });

                this.cartTotalService.postCartTotal(
                    options,
                    response => {
                        this.totals = response;
                        this.totalsUpdate.emit(response);
                        this.onKeyUp(this.loyaltyAmount, null);
                        this.updateFromInput();
                        this.removingGreenDollar = false;
                    },
                    null,
                    null,
                    null
                );
            });
    }

    onKeyUp(value: number, event: any) {
        if (event != null && event.key === "Backspace") {
            return 0;
        }
        if (value < 0 || value === null) {
            value = 0;
        }

        if (value >= this.maxLoyaltyPayable) {
            value = this.maxLoyaltyPayable;
        }

        if (this.totals.TotalCost < value) {
            value = this.totals.TotalCost;
        }
        if (
            value !== this.maxLoyaltyPayable &&
            this.maxLoyaltyPayable - value < 1
        ) {
            value = this.maxLoyaltyPayable;
        }

        this.processingCart = true;
        this.loyaltyAmount = value;

        if (this.removingGreenDollar) {
            const oldTravelProducts = this.totals.PaymentItems.filter(
                paymentItems =>
                    paymentItems != null &&
                    paymentItems.Description === "Travel Products"
            )[0];
            if (oldTravelProducts != null) {
                oldTravelProducts.Items = oldTravelProducts.Items.filter(
                    item => item.ProductCode !== "GRNDOLLAR"
                );
            }
            this.totals.PaymentItems = this.totals.PaymentItems.filter(
                paymentItems => paymentItems != null && paymentItems.Description !== "Travel Products"
            );
            this.totals.PaymentItems.push(oldTravelProducts);
        }

        const options = this.cartTotalService.getExpressCartTotalOptions(
            this.booking.travels,
            1,
            null,
            false,
            this.customerGuid
        );
        console.log("flag E this.addons", JSON.stringify(this.addons));
        this.addons.forEach(addon => {
            if (
                addon.productCode === "GRNDOLLAR" &&
                this.removingGreenDollar === true
            ) {
                console.log("ignoring green dollar on purpose!");
            } else {
                options.CartItems.push(addon);
            }
        });
        const loyaltyItem = new CartItemOptions();
        loyaltyItem.SalePriceUnit = value;
        loyaltyItem.Type = "LOY";
        loyaltyItem.Quantity = 1;
        options.CartItems.push(loyaltyItem);
        options.BookingGUID = this.bookingGuid;
        this.cartTotalService.postCartTotal(
            options,
            response => {
                let correctResponse = false;
                response.PaymentItems.forEach(paymentItem => {
                    if (paymentItem.Sku === "FE") {
                        this.processingFee = paymentItem.Total;
                    }
                    if (paymentItem.Sku === "LOY") {
                        if (paymentItem.Total === this.loyaltyAmount * -1) {
                            correctResponse = true;
                        }
                    }
                });

                if (correctResponse === false) {
                    return;
                }

                this.balanceToPay = response.TotalCost;

                if (this.balanceToPay < 0) {
                    this.balanceToPay = 0;
                }

                if (this.balanceToPay > 0) {
                    this.partialLoyaltyPayment = true;
                    this.loyaltyTotals = response;
                } else {
                    this.partialLoyaltyPayment = false;
                    this.loyaltyTotals = response;
                }
                this.processingCart = false;
                response.PaymentItems.forEach(paymentItem => {
                    if (paymentItem.Sku === "FE") {
                        this.processingFee = paymentItem.Total;
                    }
                });
                // this.loyaltyAccrued = response.CreditsEarned;
                // this.loyaltyRedemption = response.RedemptionPortion;
            },
            null,
            null,
            null
        );
        const decimalValue = this.pipe.transform(value, "1.2-2");

        this.loyaltyAmount = value;
    }

    toggleCcActive() {
        this.alertsTNS = null;
        this.alertsLoyalty = null;
        this.alertsPayPal = null;
        this.onKeyUp(0, null);
        if (!this.ccActive) {
            this.ccActive = true;
            this.paypalActive = false;
            this.loyaltyDollarsActive = false;
        }
    }

    togglePaypalActive() {
        this.alertsTNS = null;
        this.alertsLoyalty = null;
        this.alertsPayPal = null;
        this.onKeyUp(0, null);
        if (!this.paypalActive) {
            this.ccActive = false;
            this.paypalActive = true;
            this.loyaltyDollarsActive = false;
        }
    }

    toggleLoyaltyDollarsActive() {
        this.alertsTNS = null;
        this.alertsLoyalty = null;
        this.alertsPayPal = null;
        if (!this.loyaltyDollarsActive) {
            this.ccActive = false;
            this.paypalActive = false;
            this.loyaltyDollarsActive = true;
        }

        this.updateFromInput();
    }

    getPaymentAmountString = (suffex: string) => {
        if (!this.totals) {
            return "";
        }
        const decimalTotalToPay = this.pipe.transform(
            this.totals.TotalCost,
            "1.2-2"
        );
        return `Pay $${decimalTotalToPay} ${suffex}`;
    };

    getPartialLoyaltyAmountString = (suffex: string) => {
        const decimalTotalToPay = this.pipe.transform(
            this.balanceToPay,
            "1.2-2"
        );
        return `Pay $${decimalTotalToPay} ${suffex}`;
    };

    getLoyaltyAmountString = (suffex: string) => {
        const decimalTotalToPay = this.pipe.transform(
            this.orderSummary,
            "1.2-2"
        );
        return `Pay $${decimalTotalToPay} ${suffex}`;
    };

    payWithLoyaltyDollars() {
        this.paying = true;
        this.alertsLoyalty = [];
        const options = new CreatePaymentOptions(
            GxConstants.PAYMENT_METHOD.LOYALTY,
            this.paymentContext,
            this.bookingGuid
        );
        options.Amount = this.orderSummary;
        options.CancelUrl = window.location.href;
        options.ItemList = _.map(
            this.loyaltyTotals.PaymentItems,
            (item: any) => ({
                name: item.Description,
                quantity: 1,
                sku: item.Sku,
                price: item.Total
            })
        );

        const tnsOptions = new TnsOptions(
            this.transactionNumber,
            "LOYALTY",
            this.orderSummary
        );

        const customerGuid = !!this.initialDataService.initialData.UserData
            ? this.initialDataService.initialData.UserData.CustomerGuid
            : null;

        const loyaltyOptions = new LoyaltyOptions(customerGuid);

        const confirmAndTicketOptions = new ConfirmAndTicketOptions(
            this.bookingGuid,
            null,
            loyaltyOptions
        );

        this.paymentService
            .createPayment(options)
            .subscribe((createPaymentResult: CreatePaymentResult) => {
                this.paymentService
                    .confirmAndTicket(confirmAndTicketOptions)
                    .subscribe(this.paymentSucceded, this.onErrorLoyalty);
            }, this.onErrorLoyalty);
    }

    payWithCreditCard() {
        this.paying = true;
        this.alertsTNS = [];
        const options = new CreatePaymentOptions(
            GxConstants.PAYMENT_METHOD.TNS,
            this.paymentContext,
            this.bookingGuid
        );
        this.paymentService
            .createPayment(options)
            .subscribe((createPaymentResult: CreatePaymentResult) => {
                this.getTransactionDetailsFromTns(createPaymentResult);
            }, this.onErrorTNS);
    }

    loyaltyPayWithCreditCard() {
        this.paying = true;

        if (this.loyaltyTotals == null) {
            this.updateCartTotal();
            setTimeout(() => {
                this.loyaltyPayWithCreditCard();
            }, 500);
            return;
        }

        this.alertsTNS = [];
        const options = new CreatePaymentOptions(
            GxConstants.PAYMENT_METHOD.TNS,
            this.paymentContext,
            this.bookingGuid
        );
        options.Amount = this.loyaltyTotals.TotalCost;
        options.TransactionReference = this.transactionNumber;
        options.PaymentDescription = "Greyhound Australia Booking";
        options.CancelUrl = window.location.href;
        options.ItemList = _.map(
            this.loyaltyTotals.PaymentItems,
            (item: any) => ({
                name: item.Description,
                quantity: 1,
                sku: item.Sku,
                price: item.Total
            })
        );
        this.paymentService
            .createPayment(options)
            .subscribe((createPaymentResult: CreatePaymentResult) => {
                this.getLoyaltyTransactionDetailsFromTns(createPaymentResult);
            }, this.onErrorTNS);
    }

    getLoyaltyTransactionDetailsFromTns = (
        createPaymentResult: CreatePaymentResult
    ) => {
        const tnsOptions = new TnsCreditCardOptions(
            this.loyaltyCcForm.get("number").value,
            this.loyaltyCcForm.get("cvv").value,
            this.loyaltyCcForm.get("month").value,
            this.loyaltyCcForm.get("year").value
        );

        // HostedForm object is provided by tnspayments.com JS library
        if (window["HostedForm"]) {
            window["HostedForm"].setMerchant(createPaymentResult.merchant);
            window["HostedForm"].updateSession(
                createPaymentResult.session,
                tnsOptions,
                this.loyaltyOnTnsReturningTransactionDetails
            );
        } else {
            this.onErrorLoyalty(new ApiError(`'HostedForm' did not load.`));
        }
    };

    getTransactionDetailsFromTns = (
        createPaymentResult: CreatePaymentResult
    ) => {
        const tnsOptions = new TnsCreditCardOptions(
            this.ccForm.get("number").value,
            this.ccForm.get("cvv").value,
            this.ccForm.get("month").value,
            this.ccForm.get("year").value
        );
        // HostedForm object is provided by tnspayments.com JS library
        if (window["HostedForm"]) {
            window["HostedForm"].setMerchant(createPaymentResult.merchant);
            window["HostedForm"].updateSession(
                createPaymentResult.session,
                tnsOptions,
                this.onTnsReturningTransactionDetails
            );
        } else {
            this.onErrorTNS(new ApiError(`'HostedForm' did not load.`));
        }
    };

    clearLocalStorage() {
        this.localStorageService.saveTravelPassengers(null);
        this.localStorageService.saveTravelAvailability(null);
        this.localStorageService.saveTimeTableTravelOptions(null);
        this.localStorageService.saveTimeTableTravelOptions(null);
    }

    loyaltyOnTnsReturningTransactionDetails = (tnsResponse: TnsResponse) => {
        switch (tnsResponse.status) {
            case GxConstants.TNS_RESPONSE_STATUSES.OK:
                const tnsOptions = new TnsOptions(
                        this.transactionNumber,
                        tnsResponse.session,
                        this.loyaltyTotals.TotalCost
                    ),
                    confirmAndTicketOptions = new ConfirmAndTicketOptions(
                        this.bookingGuid,
                        tnsOptions,
                        null
                    );
                if (this.productType !== ProductTypeUrl.manageBooking) {
                    this.paymentService
                        .confirmAndTicket(confirmAndTicketOptions)
                        .subscribe(this.paymentSucceded, this.onErrorTNS);
                } else {
                    this.paymentService
                        .confirmAndTicket(confirmAndTicketOptions)
                        .subscribe(this.paymentSucceded, this.onErrorTNS);
                }
                this.clearLocalStorage();
                break;

            case GxConstants.TNS_RESPONSE_STATUSES.TIMEOUT:
                this.onErrorTNS(
                    new ApiError(
                        "Request has timed out. Your credit card has not been charged. Please try again."
                    )
                );
                break;
            case GxConstants.TNS_RESPONSE_STATUSES.INVALID_SESSION:
                this.onErrorTNS(
                    new ApiError(
                        "Invalid session with payment provider please try again later or contact Greyhound for clarification."
                    )
                );
                break;
            case GxConstants.TNS_RESPONSE_STATUSES.VALIDATION_ERROR:
                let err;
                if (tnsResponse.fieldsInError.cardNumber === "invalid") {
                    err = "Your credit card number is invalid.";
                } else if (
                    tnsResponse.fieldsInError.cardExpiryMonth === "invalid"
                ) {
                    err = "Your expiry month is invalid.";
                } else if (
                    tnsResponse.fieldsInError.cardExpiryYear === "invalid"
                ) {
                    err = "Your expiry year is invalid.";
                } else if (
                    tnsResponse.fieldsInError.cardSecurityCode === "invalid"
                ) {
                    err = "Your security code is invalid.";
                } else {
                    err = "Invalid credit card details.";
                }
                this.onErrorTNS(new ApiError(err));
                break;

            default:
                this.onErrorTNS(
                    new ApiError(
                        `TNS error status '${tnsResponse.status}' is unknown.`
                    )
                );
                break;
        }
    };

    onTnsReturningTransactionDetails = (tnsResponse: TnsResponse) => {
        switch (tnsResponse.status) {
            case GxConstants.TNS_RESPONSE_STATUSES.OK:
                const tnsOptions = new TnsOptions(
                        this.transactionNumber,
                        tnsResponse.session,
                        this.totals.TotalCost
                    ),
                    confirmAndTicketOptions = new ConfirmAndTicketOptions(
                        this.bookingGuid,
                        tnsOptions,
                        null
                    );
                if (this.productType !== ProductTypeUrl.manageBooking) {
                    this.paymentService
                        .confirmAndTicket(confirmAndTicketOptions)
                        .subscribe(this.paymentSucceded, this.onErrorTNS);
                } else {
                    this.paymentService
                        .confirmAndTicket(confirmAndTicketOptions)
                        .subscribe(this.paymentSucceded, this.onErrorTNS);
                }
                this.clearLocalStorage();
                break;

            case GxConstants.TNS_RESPONSE_STATUSES.TIMEOUT:
                this.onErrorTNS(
                    new ApiError(
                        "Request has timed out. Your credit card has not been charged. Please try again."
                    )
                );
                break;
            case GxConstants.TNS_RESPONSE_STATUSES.INVALID_SESSION:
                this.onErrorTNS(
                    new ApiError(
                        "Invalid session with payment provider please try again later or contact Greyhound for clarification."
                    )
                );
                break;
            case GxConstants.TNS_RESPONSE_STATUSES.VALIDATION_ERROR:
                let err;
                if (tnsResponse.fieldsInError.cardNumber === "invalid") {
                    err = "Your credit card number is invalid.";
                } else if (
                    tnsResponse.fieldsInError.cardExpiryMonth === "invalid"
                ) {
                    err = "Your expiry month is invalid.";
                } else if (
                    tnsResponse.fieldsInError.cardExpiryYear === "invalid"
                ) {
                    err = "Your expiry year is invalid.";
                } else if (
                    tnsResponse.fieldsInError.cardSecurityCode === "invalid"
                ) {
                    err = "Your security code is invalid.";
                } else {
                    err = "Invalid credit card details.";
                }
                this.onErrorTNS(new ApiError(err));
                break;

            default:
                this.onErrorTNS(
                    new ApiError(
                        `TNS error status '${tnsResponse.status}' is unknown.`
                    )
                );
                break;
        }
    };

    paymentSucceded = () => {
        if (
            this.paymentContext === GxConstants.PAYMENT_CONTEXT.MANAGE ||
            this.productType === ProductTypeUrl.manageBooking
        ) {
            this.localStorageService.removePromoCode();
            window.location.href = `/my-greyhound/booking-management/details?booking=${
                this.bookingGuid
            }&successMessage=${"Add-on purchase successful!"}`;
        } else {
            this.localStorageService.removePromoCode();
            // needs to be a full reload otherwise the booking.com won't be rendered
            // tslint:disable-next-line:max-line-length
            if (this.productType === ProductTypeUrl.expressBooking) {
                window.location.href = `${
                    this.initialDataService.express.ConfirmationUrl
                }?booking=${this.bookingGuid}&type=${
                    GxConstants.PAYMENT_CONTEXT.CONFIRMATION
                }`;
            } else {
                window.location.href = `${
                    this.initialDataService.express.ConfirmationUrl
                }?booking=${this.bookingGuid}&type=${
                    GxConstants.PAYMENT_CONTEXT.CONFIRMATION
                }`;
            }
        }
    };

    payWithPayPal() {
        this.paying = true;
        const options = new CreatePaymentOptions(
            GxConstants.PAYMENT_METHOD.PAYPAL,
            this.paymentContext,
            this.bookingGuid
        );
        this.alertsPayPal = [];
        options.Amount = this.totals.TotalCost;
        options.TransactionReference = this.transactionNumber;
        options.PaymentDescription = "Greyhound Australia Booking";
        options.CancelUrl = window.location.href;
        options.ItemList = _.map(this.totals.PaymentItems, (item: any) => ({
            name: item.Description,
            quantity: 1,
            sku: item.Sku,
            price: item.Total
        }));

        this.paymentService
            .createPayment(options)
            .subscribe((createPaymentResult: CreatePaymentResult) => {
                const redirectUrl = createPaymentResult.Message;
                // redirect to PayPal
                window.location.href = redirectUrl;
            }, this.onErrorPaypal);
    }

    loyaltyPayWithPayPal() {
        this.paying = true;

        if (this.loyaltyTotals == null) {
            this.updateCartTotal();
            setTimeout(() => {
                this.loyaltyPayWithPayPal();
            }, 500);
            return;
        }

        const options = new CreatePaymentOptions(
            GxConstants.PAYMENT_METHOD.PAYPAL,
            this.paymentContext,
            this.bookingGuid
        );
        this.alertsPayPal = [];
        options.Amount = this.loyaltyTotals.TotalCost;
        options.TransactionReference = this.transactionNumber;
        options.PaymentDescription = "Greyhound Australia Booking";
        options.CancelUrl = window.location.href;
        options.ItemList = _.map(
            this.loyaltyTotals.PaymentItems,
            (item: any) => ({
                name: item.Description,
                quantity: 1,
                sku: item.Sku,
                price: item.Total
            })
        );

        this.paymentService
            .createPayment(options)
            .subscribe((createPaymentResult: CreatePaymentResult) => {
                const redirectUrl = createPaymentResult.Message;
                // redirect to PayPal
                window.location.href = redirectUrl;
            }, this.onErrorPaypal);
    }

    onError = (error: ApiError) => {
        this.actionUpdaterService.announceError(error);
    };

    private updateLoyaltyBalance() {
        if(!!this.customerGuid){
            this.myGreyhoundService
            .getLoyaltyBalance(this.customerGuid)
            .subscribe(response => {
                this.loyaltyAvailable = response.LoyaltyAvailable;
                this.loyaltyPending = response.LoyaltyPending;
                this.balanceTime = response.BalanceDate;
                this.totalLoyalty = this.loyaltyAvailable + this.loyaltyPending;
                this.loadingBalance = false;

                if (this.orderSummary < this.loyaltyAvailable) {
                    this.maxLoyaltyPayable = this.orderSummary;
                } else {
                    this.maxLoyaltyPayable = this.loyaltyAvailable;
                }

                if (
                    this.greenDollarTotal > 0 &&
                    this.loyaltyAvailable > this.orderSummary
                ) {
                    console.log(
                        "flag a, greenDollarTotal",
                        this.greenDollarTotal
                    );
                    this.maxLoyaltyPayable -= this.greenDollarTotal;
                }
                this.updateFromInput();
            }, this.onError);
        }
    }

    private updateCartTotal() {
        const options = this.cartTotalService.getExpressCartTotalOptions(
            this.booking.travels,
            1,
            null,
            false,
            this.customerGuid
        );
        this.addons.forEach(addon => {
            if (
                addon.productCode === "GRNDOLLAR" &&
                this.removingGreenDollar === true
            ) {
            } else {
                options.CartItems.push(addon);
            }
        });

        const loyaltyItem = new CartItemOptions();
        loyaltyItem.SalePriceUnit = this.loyaltyAmount;
        loyaltyItem.Type = "LOY";
        loyaltyItem.Quantity = 1;
        options.CartItems.push(loyaltyItem);
        options.BookingGUID = this.bookingGuid;
        this.cartTotalService.postCartTotal(
            options,
            response => {
                this.loyaltyTotals = response;
            },
            this.onError,
            null,
            null
        );
    }
    private onGenericError() {
        this.paying = false;
        this.loadingData = false;
    }
    onErrorTNS = (error: ApiError) => {
        this.paying = false;
        this.onGenericError();
        this.alertsTNS = [error];
    };
    onErrorPaypal = (error: ApiError) => {
        this.paying = false;
        this.onGenericError();
        this.alertsPayPal = [error];
    };
    onErrorLoyalty = (error: ApiError) => {
        this.paying = false;
        this.onGenericError();
        this.alertsLoyalty = [error];
    };
}



// WEBPACK FOOTER //
// ./src/app/travel-products/product-payment/payment-form/payment-form.component.ts